export default __webpack_public_path__ + "static/media/loading.830aab64.gif";